export default "__VITE_ASSET__CO9re9xq__"